var map = {
	"./Leste.svg": "922a",
	"./Nordeste.svg": "6a68",
	"./Noroeste.svg": "40e2",
	"./Norte.svg": "95ab",
	"./Oeste.svg": "ed0c",
	"./Sudoeste.svg": "5fb1",
	"./Sul.svg": "4615",
	"./Suldeste.svg": "e6dd"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "c5d3";